import { render, staticRenderFns } from "./JudgingDashboard.vue?vue&type=template&id=6fbd3477"
import script from "./JudgingDashboard.vue?vue&type=script&lang=js"
export * from "./JudgingDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports